import { Box, Cross1Icon } from "@shared/primitive-components"
import * as styles from "../../styles"

type RemoveTspButtonProps = {
  tspId: string
  onRemove: (tspId: string) => void
}
export const RemoveTspButton = ({ tspId, onRemove }: RemoveTspButtonProps) => (
  <Box css={styles.RemoveButton} onClick={() => onRemove(tspId)}>
    <Cross1Icon />
  </Box>
)
